// src/mocks/handlers.js

import { rest } from 'msw';

export const handlers = [
    rest.get('/api/content/cms/cities', (req, res, ctx) => {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        return res(ctx.status(200), ctx.json(require('./top_merchants.json')));
    }),
    rest.get('/api/wallet', (req, res, ctx) => {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        return res(ctx.status(200), ctx.json(require('./wallet.json')));
    }),
];
